(function () {
    "use strict";

    angular.module('iMatApp')
        .factory("leadTimesService", leadTimesService);

    leadTimesService.$inject = ["$http", "guard"];

    function leadTimesService($http, guard) {
        var baseUrl = "/3dprint/materials";

        return {
            getLeadTime: getLeadTime
        };

        function getLeadTime(materialId, colourId) {
            guard.argumentIsString(materialId, "materialId");
            guard.argumentIsString(colourId, "colourId");

            var requestUrl = baseUrl + "/" + materialId + "/colours/" + colourId + "/lead-time";
            return $http.get(requestUrl)
                .then(function (response) {
                    return response.data;
                });
        }
    }
}());